// helper for parsing list from markdown
const getListFromDesc = desc => (
  desc.split('\r\n').map(item => item.substr(
    item.indexOf('.') + 1, item.length).trim()
  )
)

export default getListFromDesc
